// The new code uses only native promises. However, the old legacy code still uses jQuery Deferred objects.
// jQuery Deferred objects are cast to regular promises, so there's no problem there.
// However, regular promises don't have the special methods declared on Deferred objects. So, we need to add them to
//  native promises to prevent the legacy code from crashing.
//
// In any case, Deferred objects must be removed. This polyfill will need to be removed as soon as the last Deferred
//  object is replaced with native promises.

try {
  (() => {
    Promise.prototype.done = Promise.prototype.then;
    Promise.prototype.fail = Promise.prototype.catch;
    Promise.prototype.always = Promise.prototype.finally;
  })();
  console.log('[Polyfills] Promise jQuery methods polyfill added.');
} catch (err) {
  console.error('[Polyfills] Unable to polyfill Promise jQuery methods', err);
}
